import { type ApiResponse } from 'tendril-v1/src/types/ApiResponse';
import { type SalesforceMapping } from 'tendril-v2/src/Data/DataSource/sync/salesforce-mappings/dto/salesforce-mapping.dto';
import routes from 'tendril-v1/src/constants/routes';
import axios from 'axios';

export async function getSalesforceMapping(organizationId: string): Promise<ApiResponse<SalesforceMapping>> {
  try {
    const mappingsUrl = `${String(routes.get.salesforce.getMappings)}/${organizationId}`;

    const salesforceMappingEntity = await axios.get<SalesforceMapping>(mappingsUrl);
    return { data: salesforceMappingEntity.data, success: true };
  } catch (e: unknown) {
    return {
      success: false,
      error: { message: `Error while getting salesforce mapping: ${JSON.stringify(e)}` },
    };
  }
}
